import { useEffect, useState, useMemo } from 'react';
import {
    Dialog, DialogContent, DialogTitle, IconButton, Card, TableContainer, Tooltip,
    Table,
    TableBody
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Box from '@mui/material/Box';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider from 'src/components/hook-form';
import { postRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import Iconify from 'src/components/iconify';
import Scrollbar from 'src/components/scrollbar';
import { isEqual } from 'lodash';
import {
    emptyRows,
    getComparator,
    TableEmptyRows,
    TableHeadCustom,
    TableNoData,
    TablePaginationCustom,
    TableSelectedAction,
    useTable,
} from 'src/components/table';
import { useBoolean } from 'src/hooks/use-boolean';
import UserTableRow from './payment-history-table-row';
import { handleErrorMessages } from 'src/components/risk-management/risk-register/feching';
const PaymentFollowUpHistory = ({ open, onClose, reload, currentItem, closeform,remaining_balance, chartsAccountList, bankInformation ,amount_paid}) => {
    const theme = useTheme();
    const table = useTable();
    const remove = useBoolean()
    const update = useBoolean()

    const TABLE_HEAD = [
        { id: '#', label: 'S.No', minWidth: 150 },
        { id: 'account_chart', label: 'Account Chart', minWidth: 150 },
        { id: 'account_type', label: 'Account Type', minWidth: 150 },
        { id: 'amount_received', label: 'Amount Received', minWidth: 150 },
        { id: 'bank_name', label: 'Bank Name', minWidth: 150 },
        { id: 'cheque_account_number', label: 'Cheque/Account Number', minWidth: 200 },
        { id: 'credit', label: 'Credit', minWidth: 100 },
        { id: 'debit', label: 'Debit', minWidth: 100 },
        { id: 'date_of_cheque', label: 'Date of Cheque', minWidth: 200 },
        { id: 'date_of_receipt', label: 'Date of Receipt', minWidth: 150 },
        { id: 'days_left', label: 'Days Left', minWidth: 120 },
        { id: 'note', label: 'Remarks / Notes', minWidth: 200 },
        { id: 'payment_method', label: 'Payment Method', minWidth: 150 },
        { id: 'remaining_balance', label: 'Remaining Balance', minWidth: 170 },
    ];


    const { enqueueSnackbar } = useSnackbar();
    const [loading, setLoading] = useState(false);
    const [actionVisible, setActionVisible] = useState(true);
    const [selectedItem, setSelectedItem] = useState({});

    const tableData = currentItem?.sov_follow_ups || [];

    const NewUserSchema = Yup.object().shape({
    });


    const defaultValues = useMemo(
        () => ({
        }),
        []
    );

    const handleEditRow = (item) => {
        setSelectedItem(item);
        update.onTrue();
    };

    const methods = useForm({
        resolver: yupResolver(NewUserSchema),
        defaultValues,
    });

    const [filters, setFilters] = useState({
        name: '',
        role: [],
        status: 'all',
    });

    const dataFiltered = applyFilter({
        inputData: tableData || [],
        comparator: getComparator(table.order, table.orderBy),
        filters,
    });

    const dataInPage = dataFiltered.length
        ? dataFiltered.slice(
            table.page * table.rowsPerPage,
            table.page * table.rowsPerPage + table.rowsPerPage
        )
        : [];

    const denseHeight = table.dense ? 52 : 72;
    const canReset = !isEqual({ name: '', role: [], status: 'all' }, filters);
    const notFound = (!dataFiltered.length && canReset) || !dataFiltered.length;

    const {
        reset,
        handleSubmit,
        formState: { isSubmitting },
    } = methods;

    useEffect(() => {
        reset(defaultValues);
    }, [currentItem, reset, defaultValues]);



    const onSubmit = handleSubmit(async (data) => {
        setLoading(true);
        const formData = new FormData();
        formData.append('risk_id', data.risk_id.id);
        data.append('approval_status', data.approval_status);
        try {
            const response = await postRequest(
                currentItem?.id
                    ? `${endpoints.risk_management.risk_change_request.crud}/${currentItem.id}?_method=PUT`
                    : endpoints.risk_management.risk_change_request.crud,
                formData,
                true
            );
            if (response.metadata && response.metadata.success) {
                reset();
                onClose();
                closeform();
                reload();
                enqueueSnackbar({
                    variant: 'success',
                    message: response.metadata.message,
                });
            } else {
                handleErrorMessages(response?.message || 'An error occurred.');
            }
        } catch (err) {
            console.error('Error:', err);
            handleErrorMessages(err.message || 'Submission failed.');
        } finally {
            setLoading(false);
        }
    });

    const closeAndReset = () => {
        reset();
        onClose();
    }

    return (
        <>
            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        closeAndReset();
                    }
                }}
                fullWidth
                maxWidth="md"
                sx={{
                    borderRadius: 'none',
                    padding: '60px',
                    fontSize: '13px',
                    fontFamily: 'arial',
                }}
                transitionDuration={{
                    enter: theme.transitions.duration.shortest,
                    exit: theme.transitions.duration.shortest - 80,
                }}
            >
                <FormProvider methods={methods} onSubmit={onSubmit}>
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', gap: 1, alignItems: 'center', boxSizing: 'content-box' }}>
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                width: '100%'
                            }}
                        >
                            <span
                                className='cardColor'
                                style={{ padding: '7px', marginLeft: '-25px', color: 'white', fontWeight: '700' }}>
                                &nbsp;&nbsp; Payment Requisitions Follow Up History  &nbsp;&nbsp;&nbsp;&nbsp;
                            </span>
                        </Box>
                        <IconButton onClick={closeAndReset}>
                            <Iconify icon="mdi:close" />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent
                        sx={{
                            borderRadius: '1px',
                        }}
                    >

                        <Card
                            sx={{
                                boxShadow: '0px 0px 30px 0px #64748B1A',
                            }}
                        >
                            <TableContainer sx={{
                                position: 'relative', overflow: 'auto'
                            }}>

                                <TableSelectedAction
                                    dense={table.dense}
                                    numSelected={table.selected.length}
                                    rowCount={tableData?.length}
                                    onSelectAllRows={(checked) =>
                                        table.onSelectAllRows(
                                            setActionVisible(checked),
                                            checked,
                                            tableData.map((row) => row.id)
                                        )
                                    }
                                    action={
                                        <Tooltip title="Delete">
                                            <IconButton color="primary" onClick={remove.onTrue}>
                                                <Iconify icon="solar:trash-bin-trash-bold" />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                />
                                <Scrollbar>
                                    <TableContainer sx={{ position: 'relative', overflow: 'unset' }}>
                                        <Scrollbar>
                                            <Table size={table.dense ? 'small' : 'medium'} >
                                                <TableHeadCustom
                                                    sx={{
                                                        whiteSpace: 'nowrap'
                                                    }}
                                                    order={table.order}
                                                    orderBy={table.orderBy}
                                                    headLabel={TABLE_HEAD}
                                                    rowCount={tableData.length}
                                                    numSelected={table.selected.length}
                                                    onSort={table.onSort}
                                                    onSelectAllRows={(checked) =>
                                                        table.onSelectAllRows(
                                                            checked,
                                                            tableData.map((row) => row.id)
                                                        )
                                                    }
                                                />
                                                <TableBody>
                                                    {dataFiltered
                                                        .slice(
                                                            table.page * table.rowsPerPage,
                                                            table.page * table.rowsPerPage + table.rowsPerPage
                                                        )
                                                        .map((row, index) => (
                                                            <UserTableRow
                                                                key={row.id}
                                                                row={row}
                                                                remaining_balance={remaining_balance}
                                                                selected={table.selected.includes(row.id)}
                                                                onSelectRow={() => table.onSelectRow(row.id)}
                                                                onEditRow={() => handleEditRow(row)}
                                                                serialNumber={table.page * table.rowsPerPage + index + 1}
                                                            />
                                                        ))}
                                                    <TableEmptyRows
                                                        height={denseHeight}
                                                        emptyRows={emptyRows(table.page, table.rowsPerPage, tableData.length)}
                                                    />

                                                    <TableNoData notFound={notFound} />
                                                </TableBody>
                                            </Table>
                                        </Scrollbar>
                                    </TableContainer>
                                </Scrollbar>
                            </TableContainer>
                            <TablePaginationCustom
                                count={dataFiltered.length}
                                page={table.page}
                                rowsPerPage={table.rowsPerPage}
                                onPageChange={table.onChangePage}
                                onRowsPerPageChange={table.onChangeRowsPerPage}
                                dense={table.dense}
                                onChangeDense={table.onChangeDense}
                            />
                        </Card>
                    </DialogContent>
                </FormProvider>
            </Dialog >
            {/* <InvoicesUpdate
                open={update.value}
                bankInformation={bankInformation}
                onClose={update.onFalse}
                reload={reload}
                amount_paid={amount_paid}
                currentItem={currentItem}
                selectedItem={selectedItem}
                chartsAccountList={chartsAccountList}
            /> */}

        </>
    );
};
function applyFilter({ inputData, comparator, filters }) {
    inputData = Array.isArray(inputData) ? inputData : []; 

    const { name, status, role } = filters;
    const stabilizedThis = inputData.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });

    inputData = stabilizedThis.map((el) => el[0]);

    if (name) {
        inputData = inputData.filter(
            (user) => user.name?.toLowerCase().indexOf(name.toLowerCase()) !== -1
        );
    }

    if (status !== 'all') {
        inputData = inputData.filter((user) => user.status === status);
    }

    if (role.length) {
        inputData = inputData.filter((user) => role.includes(user.role));
    }

    return inputData;
}

export default PaymentFollowUpHistory;